import { ColumnType } from "antd/lib/table";
import { Transaction } from "rivals/components/pages/User/BillingHistory/types";
import { TextCell } from "rivals/components/shared/Tables/Cells";
import strings from "./strings";
const { dataKeys, headers } = strings;

const transactionDate = {
  dataIndex: dataKeys.transactionDate,
  key: dataKeys.transactionDate,
  render: (billDate: string): JSX.Element => {
    return <TextCell text={billDate} />;
  },
  title: headers.transactionDate
};

const settledDate = {
  dataIndex: dataKeys.settledDate,
  key: dataKeys.settledDate,
  render: (date: string): JSX.Element => {
    return <TextCell text={date} />;
  },
  title: headers.settledDate
};

const transactionType = {
  dataIndex: dataKeys.transactionType,
  key: dataKeys.transactionType,
  render: (type: string): JSX.Element => {
    return <TextCell text={type.toUpperCase()} />;
  },
  title: headers.transactionType
};

const description = {
  dataIndex: dataKeys.description,
  key: dataKeys.description,
  render: (description: string): JSX.Element => {
    return <TextCell text={description} />;
  },
  title: headers.description
};

const totalCharge = {
  dataIndex: dataKeys.totalCharge,
  key: dataKeys.totalCharge,
  render: (totalAmount: string): JSX.Element => {
    return <TextCell text={totalAmount} />;
  },
  title: headers.totalCharge
};

export const columns: ColumnType<Transaction>[] = [
  transactionDate,
  settledDate,
  transactionType,
  description,
  totalCharge
];
